import { create } from 'zustand';
import { devtools, redux } from 'zustand/middleware';
import { queryBuilderInitialState } from './queryBuilderInitialState';
import { queryBuilderReducer } from './queryBuilderReducer';

export const createQueryBuilderStore = () =>
  create(
    devtools(redux(queryBuilderReducer, queryBuilderInitialState), {
      name: 'QueryBuilderStore',
    }),
  );
